
export enum AuditColumn {
  INITIATEDBY = 'initiatedBy',
  ACTION = 'action',
  TENANT = 'tenant',
  STATUS = 'status',
}

export const AuditColumns = Object.values(AuditColumn) as string[];
